const actions = {
  async getData({ commit, dispatch, state }, { params, query }) {
    const { columns } = state
    const { baseReportName, routeName } = params
    const root = { root: true }
    const componentName = baseReportName || routeName

    commit('tools/viewId', componentName, root)
    dispatch('tools/setup', { columns, params, query }, root)
    dispatch('messages/hideLoadingMessage', { componentName: routeName, text: 'Rendering ...' }, { root: true })
  },

  async getNetworkOverview({ dispatch }, { params, query }) {
    const endpointKey = params.baseReportName || params.routeName
    const data = await dispatch('tools/request', { endpointKey, params, query }, { root: true })
    const items = await dispatch('tools/transform', { endpointKey, data, query }, { root: true })
    const groups = await dispatch('tools/applyReportCriteria', { items, params, query }, { root: true })

    const orders = groups.reduce((itemsByOrderId, group) => {
      const { items: groupItems } = group

      groupItems.forEach((item) => {
        const { orderId } = item
        if (!itemsByOrderId[orderId]) {
          itemsByOrderId[orderId] = [item]
        } else {
          itemsByOrderId[orderId].push(item)
        }
      })

      return itemsByOrderId
    }, [])

    const totalCount = groups.reduce((itemsCount, group) => itemsCount + group.items.length, 0)

    return {
      lineitems: groups,
      orders,
      totalCount,
      orderCount: Object.keys(orders).length,
    }
  },
}

export default actions
